import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReasonidService } from 'src/app/service/reasonid.service';
import { FormControl } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-add-daily-expedite',
  templateUrl: './add-daily-expedite.component.html',
  styleUrls: ['./add-daily-expedite.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None 
})
export class AddDailyExpediteComponent implements OnInit {

  heading: string;
  errormsg
  eventType
  domicile
  period
  dailyexpediteRate
  year
  selected_position_id: any;
  TierData: any;
  periodDrpDwn;
  periodId
  selectedPeriod;
  domicileDropDown;
  toPeriodList: any;
  selected_period_id: any;
  selected_period_value: any;
  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomicileList: ReplaySubject<any[]> = new ReplaySubject(1);

  constructor(public dialogRef: MatDialogRef<AddDailyExpediteComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly targetService: ReasonidService,
    private readonly ngxUiLoaderService: NgxUiLoaderService) { }

  ngOnInit(): void {
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.periodDrpDwn = this.dataStore.periodDrpDwn
    this.domicileDropDown = this.dataStore.domicileDrpDwn
    this.filteredDomicileList.next(this.domicileDropDown?.slice() || []);
    this.domicileFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterDomicile(search) : this.domicileDropDown?.slice() || [])
      )
      .subscribe(filtered => {
        this.filteredDomicileList.next(filtered);
      });
    this.getPeriods();
    if (this.eventType == 'EDIT') { // NOSONAR
      this.domicile = this.dataStore.domicile
      this.dailyexpediteRate = this.dataStore.dailyexpediteRate
      this.domicile = this.domicileDropDown.find(x => x.label == this.dataStore.domicile) || null; // NOSONAR
      this.year = this.dataStore.year
      const match = this.toPeriodList.find(x => x.periodId == this.dataStore.periodId); // NOSONAR
      this.selected_period_id = match?.periodId ?? this.toPeriodList[0]?.periodId;
    }





  }

  private filterDomicile(search: string): any[] {
    const lowerSearch = search.toLowerCase();
    return this.domicileDropDown?.filter(option => option.label.toLowerCase().includes(lowerSearch)) || [];
  }



  getPeriods() {
    const tempPeriod = JSON.parse(localStorage.getItem("period_data"))
    if (tempPeriod && tempPeriod.length > 0) {
      this.toPeriodList = tempPeriod
      this.selected_period_id = this.toPeriodList[0].periodId;
      this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period // NOSONAR
    } else {
      this.targetService.getPeriodsList().subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response.length > 0) {
            this.toPeriodList = response
            this.selected_period_id = this.toPeriodList[0].periodId;
            this.selected_period_value = this.toPeriodList.find(x => x.periodId == this.selected_period_id).period // NOSONAR
          }
        }, error => {
          console.info(error)
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errormsg = this.constants.APIErrorMessage
          setTimeout(() => {
            this.errormsg = "";
          }, this.constants.notificationMessageTimeShort);
        }
      );
    }
  }
  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {
    this.errormsg = ""
    if (this.isValueOk(this.domicile)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.dailyexpediteRate)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.selected_period_id)) {
      this.showError(this.constants.formInputError);
    } else if (!(Number(this.dailyexpediteRate) <= 1 && Number(this.dailyexpediteRate) >= 0)) {
      this.showError("Percentage value should be in 0 - 1");
    } else {
      this.saveAPICall();
    }
  }

  componentEventHandler(event) {

    if (event.eventType == "CHANGE_PERIOD") { // NOSONAR
      this.selectedPeriod = event.periodId
      console.info(this.selectedPeriod)
    }
  }
  validate(event: any, module) {
    const t = event.target.value;
    if (module == "value") { // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 7) : t;
    }
  }
  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }


  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    if (this.eventType == "ADD") { // NOSONAR
      const updateObject = {
        regionTargetId: Number(this.dataStore.regionTargetId),
        dailyExpediteRate: this.dailyexpediteRate == "" ? null : Number(this.dailyexpediteRate?.toString().includes('.') ? this.dailyexpediteRate?.toString().split(".")[0] + "." + this.dailyexpediteRate?.toString().split(".")[1]?.substring(0, 7) : this.dailyexpediteRate), // NOSONAR
        periodId: Number(this.selected_period_id),
        domicile: this.domicile.label,
      }
      this.targetService.addTargets(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });

    }
    else if (this.eventType == "EDIT") { // NOSONAR
      const updateObject = {
        regionTargetId: Number(this.dataStore.regionTargetId),
        dailyExpediteRate: Number(this.dailyexpediteRate),
        periodId: Number(this.selected_period_id),
        domicile: this.domicile.label,
      }
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.targetService.updateTargets(updateObject).subscribe(
        response => {
          if (response == "Success") { // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }

        }, error => {
          console.info(error)
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
    {
      return true;
    }
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}


